import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

export const AnalysisTypePicker = ({ onSelect }) => {
  const { t } = useTranslation();
  return <>
    <p className="text-muted-foreground text-sm">{t("photoAnalysis.selectType")}</p>
    {[["rosto", "😊", "facial"], ["corpo", "🏃", "body"]].map(([type, icon, key]) => <button key={type} onClick={() => onSelect(type)} data-testid={`photo-type-${type}`} className="w-full bg-card border border-primary/40 rounded-xl p-6 text-left hover:border-primary hover:bg-primary/5 transition-colors">
      <div className="text-2xl mb-2">{icon}</div><h2 className="font-bold text-lg">{t(`photoAnalysis.${key}Title`)}</h2><p className="text-muted-foreground text-sm mt-1">{t(`photoAnalysis.${key}Desc`)}</p>
    </button>)}
    <div className="bg-yellow-900/20 border border-yellow-700/40 rounded-xl p-4 flex gap-3" data-testid="photo-disclaimer"><AlertTriangle className="w-5 h-5 text-yellow-500 shrink-0" /><p className="text-yellow-200/80 text-xs">{t("photoAnalysis.disclaimer")}</p></div>
  </>;
};